module.exports = __webpack_public_path__ + "img/platum@2x.f193d0e3.png";